"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScatterChartTooltip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Components_1 = require("../../../Components");
var chartUtils_1 = require("../../chartUtils");
var ChartTooltipUtils_1 = require("../ChartTooltipUtils");
var ChartTooltipStyles_1 = require("../ChartTooltipStyles");
var MAX_MONTHS = 3;
var MAX_MONTHS_MESSAGE = 'There is too much data to load for this X-value. View as grid to see all data.';
exports.ScatterChartTooltip = function (_a) {
    var data = _a.data, colorScale = _a.colorScale;
    var numMonths = data.dates.length;
    if (numMonths < 0) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (numMonths === 1) {
        return (react_1.default.createElement(ChartTooltipStyles_1.StyledContent, null,
            react_1.default.createElement(DateHeader, null, data.dates[0]),
            data.rows.map(function (row) { return (react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, { key: "tooltip-row-" + row.ID },
                react_1.default.createElement(Components_1.Icon, { name: row.icon, style: { color: colorScale(row), fontSize: '1.6rem' } }),
                react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemLabel, null, row.label),
                react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, { style: {
                        color: row.values[0] && row.values[0] < 0
                            ? ChartTooltipUtils_1.NEGATIVE_COLOR
                            : ChartTooltipUtils_1.POSITIVE_COLOR,
                    } }, row.values[0] !== null ? chartUtils_1.formatLinearNumbers(row.values[0]) : ''))); })));
    }
    if (numMonths <= MAX_MONTHS) {
        return (react_1.default.createElement(ChartTooltipStyles_1.StyledContent, null,
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, null,
                react_1.default.createElement(DateRow, null, data.dates.map(function (date) { return (react_1.default.createElement(DateLabel, { key: "tooltip-date-" + date }, date)); }))),
            data.rows.map(function (row) { return (react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, { key: "tooltip-row-" + row.ID },
                react_1.default.createElement(Components_1.Icon, { name: row.icon, style: { color: colorScale(row), fontSize: '1.6rem' } }),
                react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemLabel, null, row.label),
                row.values.map(function (v, i) { return (react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, { key: "tooltip-row-" + row.ID + "-" + i, style: {
                        color: v && v < 0 ? ChartTooltipUtils_1.NEGATIVE_COLOR : ChartTooltipUtils_1.POSITIVE_COLOR,
                    } }, v !== null ? chartUtils_1.formatLinearNumbers(v) : '')); }))); })));
    }
    return react_1.default.createElement(ChartTooltipStyles_1.StyledContent, null, MAX_MONTHS_MESSAGE);
};
exports.ScatterChartTooltip.displayName = 'FOS__ScatterChartTooltip';
var DateHeader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 0.8rem 0rem 1.2rem 0rem;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0.8rem 0rem 1.2rem 0rem;\n"])));
var DateRow = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-left: 17rem;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-left: 17rem;\n"])));
var DateLabel = styled_components_1.default.span(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  width: 7.6rem;\n  text-align: right;\n"], ["\n  font-family: ", ";\n  width: 7.6rem;\n  text-align: right;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
});
var templateObject_1, templateObject_2, templateObject_3;
